// frontend/src/context/DashboardRefreshContext.js
// Project:      Vision ANPR by Castle Traffic Ltd - Dashboard Refresh Context
// Author:       Leon du Plooy - Castle Traffic Ltd
// Contact:      dev@castle-traffic.co.uk
// Created:      2025-07-10
// Updated:      2025-07-10
//
// Description:  Provides a global refresh context so that components (e.g. widgets, lists) can 
//               auto-reload when changes are made (e.g. on customer update).

import React, { createContext, useContext, useState } from "react";

const DashboardRefreshContext = createContext();

export const DashboardRefreshProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(Date.now());

  const triggerRefresh = () => {
    setRefreshKey(Date.now());
  };

  return (
    <DashboardRefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      {children}
    </DashboardRefreshContext.Provider>
  );
};

export const useDashboardRefresh = () => useContext(DashboardRefreshContext);
